import _ from 'lodash';
import { CALL_API } from '../../../middleware/api';
import * as API from '../../../services/ApiEndpointsConstants';
import { apiEndpoints } from '../../../services/ApiEndpointsConstants';
import * as SearchConstants from './SearchConstants';

export function addManyNewDomainsToBlacklisted(requestData) {
  return {
    [CALL_API]: {
      config: {
        data: requestData,
        method: 'post'
      },
      endpoint: apiEndpoints().entity(API.BLACKLISTED_DOMAIN_BATCH_URI),
      types: [
        SearchConstants.ADD_MANY_NEW_DOMAINS_TO_BLACKLISTED_REQUEST,
        SearchConstants.ADD_MANY_NEW_DOMAINS_TO_BLACKLISTED_SUCCESS,
        SearchConstants.ADD_MANY_NEW_DOMAINS_TO_BLACKLISTED_FAILED
      ]
    }
  };
}

export function deleteDomainFromBlacklist(domainId) {
  return {
    [CALL_API]: {
      config: {
        method: 'delete'
      },
      endpoint: apiEndpoints()
        .entity(API.DELETE_DOMAIN_FROM_BLACKLIST)
        .replace('{domainId}', domainId),
      types: [
        SearchConstants.DELETE_DOMAIN_FROM_BLACKLIST_REQUEST,
        SearchConstants.DELETE_DOMAIN_FROM_BLACKLIST_SUCCESS,
        SearchConstants.DELETE_DOMAIN_FROM_BLACKLIST_FAILED
      ]
    }
  };
}

export function getImagesTableFieldsData() {
  return {
    [CALL_API]: {
      endpoint: apiEndpoints().entity(API.GET_IMAGE_FIELDS_DATA),
      types: [
        SearchConstants.GET_IMAGES_TABLE_FIELDS_DATA_REQUEST,
        SearchConstants.GET_IMAGES_TABLE_FIELDS_DATA_SUCCESS,
        SearchConstants.GET_IMAGES_TABLE_FIELDS_DATA_FAILED
      ]
    }
  };
}

export function getDomainByName(
  requestData,
  paginationOptions,
  sortingOptions = {}
) {
  let domainsSortingString = '';

  if (!_.isEmpty(sortingOptions)) {
    _.forEach(
      Object.keys(sortingOptions),
      (opKey) =>
        (domainsSortingString +=
          '&sort=' +
          opKey
            .toLowerCase()
            .split('_')
            .map((name, index) =>
              index !== 0 ? name.charAt(0).toUpperCase() + name.slice(1) : name
            )
            .join('') +
          ',' +
          sortingOptions[opKey].type.toLowerCase())
    );
  }

  return {
    [CALL_API]: {
      config: {
        method: 'post',
        data: requestData,
        'Access-Control-Request-Headers': 'content-type'
      },
      endpoint: `${apiEndpoints().entity(API.GET_DOMAIN_BY_NAME)}?page=${
        paginationOptions.page
      }&size=${paginationOptions.size}${domainsSortingString}`,
      types: [
        SearchConstants.GET_DOMAIN_BY_NAME_REQUEST,
        SearchConstants.GET_DOMAIN_BY_NAME_SUCCESS,
        SearchConstants.GET_DOMAIN_BY_NAME_FAILED
      ]
    }
  };
}

export function getDomainsByUsageUrl(
  requestData,
  paginationOptions,
  sortingOptions = {}
) {
  const getType = (state) => {
    if (_.isUndefined(state.type)) return state;

    return state.type.toLowerCase();
  };

  const getLowerIfType = (key, state) => {
    if (_.isUndefined(state.type)) return key;

    return key.toLowerCase();
  };

  const sort = Object.keys(sortingOptions).reduce((sort, key) => {
    if (sortingOptions[key]) {
      sort +=
        '&sort=' +
        getLowerIfType(key, sortingOptions[key])
          .split('_')
          .map((name, index) =>
            index !== 0 ? name.charAt(0).toUpperCase() + name.slice(1) : name
          )
          .join('') +
        ',' +
        getType(sortingOptions[key]);
    }

    return sort;
  }, '');

  let endpoint = `${apiEndpoints().entity(API.GET_DOMAINS_BY_USAGE_URL)}?page=${
    paginationOptions.page
  }&size=${paginationOptions.size}${sort}`;

  return {
    [CALL_API]: {
      config: {
        method: 'post',
        data: requestData,
        'Access-Control-Request-Headers': 'content-type'
      },
      endpoint,
      types: [
        SearchConstants.GET_DOMAINS_BY_USAGE_URL_REQUEST,
        SearchConstants.GET_DOMAINS_BY_USAGE_URL_SUCCESS,
        SearchConstants.GET_DOMAINS_BY_USAGE_URL_FAILED
      ]
    }
  };
}

export function getDomainsByClickhouseUsageUrl(
  requestData,
  paginationOptions,
  sortingOptions = {}
) {
  const getType = (state) => {
    if (_.isUndefined(state.type)) return state;

    return state.type.toLowerCase();
  };

  const getLowerIfType = (key, state) => {
    if (_.isUndefined(state.type)) return key;

    return key.toLowerCase();
  };

  const sort = Object.keys(sortingOptions).reduce((sort, key) => {
    if (sortingOptions[key]) {
      sort +=
        '&sort=' +
        getLowerIfType(key, sortingOptions[key])
          .split('_')
          .map((name, index) =>
            index !== 0 ? name.charAt(0).toUpperCase() + name.slice(1) : name
          )
          .join('') +
        ',' +
        getType(sortingOptions[key]);
    }

    return sort;
  }, '');

  let endpoint = `${apiEndpoints().entity(
    API.GET_DOMAINS_BY_CLICKHOUSE_USAGE_URL
  )}?page=${paginationOptions.page}&size=${paginationOptions.size}${sort}`;

  return {
    [CALL_API]: {
      config: {
        method: 'post',
        data: requestData,
        'Access-Control-Request-Headers': 'content-type'
      },
      endpoint,
      types: [
        SearchConstants.GET_DOMAINS_BY_CLICKHOUSE_USAGE_URL_REQUEST,
        SearchConstants.GET_DOMAINS_BY_CLICKHOUSE_USAGE_URL_SUCCESS,
        SearchConstants.GET_DOMAINS_BY_CLICKHOUSE_USAGE_URL_FAILED
      ]
    }
  };
}

export function getDomainsByClickhouseArchiveUsageUrl(
  requestData,
  paginationOptions,
  sortingOptions = {}
) {
  const getType = (state) => {
    if (_.isUndefined(state.type)) return state;

    return state.type.toLowerCase();
  };

  const getLowerIfType = (key, state) => {
    if (_.isUndefined(state.type)) return key;

    return key.toLowerCase();
  };

  const sort = Object.keys(sortingOptions).reduce((sort, key) => {
    if (sortingOptions[key]) {
      sort +=
        '&sort=' +
        getLowerIfType(key, sortingOptions[key])
          .split('_')
          .map((name, index) =>
            index !== 0 ? name.charAt(0).toUpperCase() + name.slice(1) : name
          )
          .join('') +
        ',' +
        getType(sortingOptions[key]);
    }

    return sort;
  }, '');

  let endpoint = `${apiEndpoints().entity(
    API.GET_DOMAINS_BY_CLICKHOUSE_ARCHIVE_USAGE_URL
  )}?page=${paginationOptions.page}&size=${paginationOptions.size}${sort}`;

  return {
    [CALL_API]: {
      config: {
        method: 'post',
        data: requestData,
        'Access-Control-Request-Headers': 'content-type'
      },
      endpoint,
      types: [
        SearchConstants.GET_DOMAINS_BY_CLICKHOUSE_USAGE_URL_REQUEST,
        SearchConstants.GET_DOMAINS_BY_CLICKHOUSE_USAGE_URL_SUCCESS,
        SearchConstants.GET_DOMAINS_BY_CLICKHOUSE_USAGE_URL_FAILED
      ]
    }
  };
}

export function getUsageUrlCount(id) {
  return {
    [CALL_API]: {
      endpoint: `${apiEndpoints().entity(API.GET_USAGE_URL_COUNT)}/${id}`,
      types: [
        SearchConstants.GET_USAGE_URL_COUNT_REQUEST,
        SearchConstants.GET_USAGE_URL_COUNT_SUCCESS,
        SearchConstants.GET_USAGE_URL_COUNT_FAILED
      ]
    }
  };
}

export function getBlacklistedDomainByName(
  domain,
  paginationOptions,
  sortingOptions = {}
) {
  let blacklistedSortingString = '';

  if (!_.isEmpty(sortingOptions)) {
    _.forEach(
      Object.keys(sortingOptions),
      (opKey) =>
        (blacklistedSortingString +=
          '&sort=' +
          opKey
            .toLowerCase()
            .split('_')
            .map((name, index) =>
              index !== 0 ? name.charAt(0).toUpperCase() + name.slice(1) : name
            )
            .join('') +
          ',' +
          sortingOptions[opKey].type.toLowerCase())
    );
  }

  return {
    [CALL_API]: {
      endpoint: `${apiEndpoints().entity(
        API.GET_BLACKLISTED_DOMAIN_BY_NAME
      )}?page=${paginationOptions.page}&size=${
        paginationOptions.size
      }${blacklistedSortingString}&domain=${domain}`,
      types: [
        SearchConstants.GET_BLACKLISTED_DOMAIN_BY_NAME_REQUEST,
        SearchConstants.GET_BLACKLISTED_DOMAIN_BY_NAME_SUCCESS,
        SearchConstants.GET_BLACKLISTED_DOMAIN_BY_NAME_FAILED
      ]
    }
  };
}

export function getImagesByAgencyAndId(
  requestData,
  paginationOptions,
  sortingOptions = {}
) {
  let imagesSortingString = '';

  if (!_.isEmpty(sortingOptions)) {
    _.forEach(
      Object.keys(sortingOptions),
      (opKey) =>
        (imagesSortingString +=
          '&sort=' +
          opKey
            .toLowerCase()
            .split('_')
            .map((name, index) =>
              index !== 0 ? name.charAt(0).toUpperCase() + name.slice(1) : name
            )
            .join('') +
          ',' +
          sortingOptions[opKey].type.toLowerCase())
    );
  }

  return {
    [CALL_API]: {
      config: {
        method: 'post',
        data: requestData,
        'Access-Control-Request-Headers': 'content-type'
      },
      endpoint: `${apiEndpoints().entity(
        API.GET_IMAGES_BY_AGENCY_AND_ID
      )}?page=${paginationOptions.page}&size=${
        paginationOptions.size
      }${imagesSortingString}`,
      types: [
        SearchConstants.GET_IMAGES_BY_AGENCY_AND_ID_REQUEST,
        SearchConstants.GET_IMAGES_BY_AGENCY_AND_ID_SUCCESS,
        SearchConstants.GET_IMAGES_BY_AGENCY_AND_ID_FAILED
      ]
    }
  };
}

export function getDomainFlowStatuses() {
  return {
    [CALL_API]: {
      endpoint: apiEndpoints().entity(API.GET_DOMAIN_FLOW_STATUSES),
      types: [
        SearchConstants.GET_DOMAIN_FLOW_STATUSES_REQUEST,
        SearchConstants.GET_DOMAIN_FLOW_STATUSES_SUCCESS,
        SearchConstants.GET_DOMAIN_FLOW_STATUSES_FAILED
      ]
    }
  };
}

export function getCountriesList() {
  return {
    [CALL_API]: {
      endpoint: apiEndpoints().entity(API.GET_COUNTRIES_LIST),
      types: [
        SearchConstants.GET_COUNTRIES_LIST_REQUEST,
        SearchConstants.GET_COUNTRIES_LIST_SUCCESS,
        SearchConstants.GET_COUNTRIES_LIST_FAILED
      ]
    }
  };
}

export const changeUsageImagesData = (ids, status) => {
  return {
    type: SearchConstants.CHANGE_USAGE_IMAGES_DATA,
    payload: {
      imageIds: ids,
      status
    }
  };
};

export const changeClickhouseUsageImagesData = (ids, status) => {
  return {
    type: SearchConstants.CHANGE_CLICKHOUSE_USAGE_IMAGES_DATA,
    payload: {
      imageIds: ids,
      status
    }
  };
};
